export default {
  Title: 'Thêm mới từ chứng từ hiện thời',
  SelectVoucherType: 'Chọn loại chứng từ',
  VoucherOption1: 'Phiếu thu',
  VoucherOption2: 'Chứng từ nghiệp vụ khác',
  VoucherOption3: 'Phiếu rút tiền kho bạc',
  VoucherOption4: 'Phiếu nộp tiền kho bạc',
  VoucherOption5: 'Phiếu chi',
  VoucherOption6: 'Chuyển khoản kho bạc',
  VoucherOption7: 'Hạch toán chi phí lương, BH, KPCĐ',
  BuTransferDepositOption: 'Chuyển khoản kho bạc vào tài khoản tiền gửi',
  BAWithDraw: 'Chi tiền gửi',
  UpdateAccountAfterClone: 'Cập nhật tài khoản sau sao chép',
  CreditAccount: 'TK Nợ',
  CreditAccountTooltip: 'Tài khoản Nợ',
  DebitAccount: 'TK Có',
  DebitAccountTooltip: 'Tài khoản Có',
  Cancel: 'Hủy bỏ',
};
